define('TescoMobile_Checkout/js/model/checkout-data-resolver-mixin',['Magento_Checkout/js/model/quote', 'Magento_Checkout/js/checkout-data', 'mage/utils/wrapper'], function (quote, checkoutData, wrapper) {
  var mixin = {
    resolveCustomer: function () {
      if (!checkoutData.getCustomer() && quote.getData('customer_firstname')) {
        const customer = {
          prefix: quote.getData('customer_prefix'),
          firstname: quote.getData('customer_firstname'),
          lastname: quote.getData('customer_lastname'),
          tm_contact_number: quote.getData('customer_tm_contact_number'),
          dob: quote.getData('customer_dob'),
          email: quote.getData('email')
        };
        checkoutData.setCustomer(customer);
      }
    },
    resolvePreviousAddress: function () {
      if (!checkoutData.getPreviousAddress() && quote.getData('tm_previous_address')) {
        checkoutData.setPreviousAddress(quote.getData('tm_previous_address'));
      }
    },
    resolveMarketingPreferences: function () {
      if (!checkoutData.getMarketingPreferences() && (quote.getData('customer_tm_consent_tesco_mobile') || quote.getData('customer_tm_consent_tesco_stores') || quote.getData('customer_tm_consent_tesco_bank'))) {
        checkoutData.setMarketingPreferences({
          tm_consent_tesco_mobile: Number(quote.getData('customer_tm_consent_tesco_mobile')),
          tm_consent_tesco_stores: Number(quote.getData('customer_tm_consent_tesco_stores')),
          tm_consent_tesco_bank: Number(quote.getData('customer_tm_consent_tesco_bank'))
        });
      }
    },
    resolveCardPayment: function () {
      if (!checkoutData.getCardPayment() && quote.getData('customer_tm_card_payment')) {
        checkoutData.setPayment(quote.getData('customer_tm_card_payment'));
      }
    },
    resolveMonthlyPaymentDirectDebit: function () {
      if (!checkoutData.getMonthlyPaymentDirectDebit() && (quote.getData('customer_tm_direct_debit_account_holder_name') || quote.getData('customer_tm_direct_debit_account_number') || quote.getData('customer_tm_direct_debit_sort_code') || quote.getData('customer_tm_bill_preferred_notification') || quote.getData('customer_tm_bill_group_id'))) {
        checkoutData.setMonthlyPaymentDirectDebit({
          tm_direct_debit_account_holder_name: quote.getData('customer_tm_direct_debit_account_holder_name'),
          tm_direct_debit_account_number: quote.getData('customer_tm_direct_debit_account_number'),
          tm_direct_debit_sort_code: quote.getData('customer_tm_direct_debit_sort_code'),
          tm_bill_preferred_notification: quote.getData('customer_tm_bill_preferred_notification'),
          tm_direct_debit_bill_group_id: quote.getData('customer_tm_bill_group_id')
        });
      }
    },
    resolveMonthlyPaymentCard: function () {
      if (!checkoutData.getMonthlyPaymentCard() && (quote.getData('customer_tm_card_type') || quote.getData('customer_tm_card_number') || quote.getData('customer_tm_expiry_type'))) {
        checkoutData.setMonthlyPaymentCard({
          card_type: quote.getData('customer_tm_card_type'),
          card_number: quote.getData('customer_tm_card_number'),
          expiry_date: quote.getData('customer_tm_expiry_date')
        });
      }
    }
  };
  return function (target) {
    return wrapper.extend(target, mixin);
  };
});

